// function getPageList(totalPages, page, maxLength) {
//   if (maxLength < 5) throw "maxLength must be at least 5";

//   function range(start, end) {
//     return Array.from(Array(end - start + 1), (_, i) => i + start);
//   }

//   var sideWidth = maxLength < 11 ? 1 : 2;
//   var leftWidth = (maxLength - sideWidth * 2 - 3) >> 1;
//   var rightWidth = (maxLength - sideWidth * 2 - 2) >> 1;
//   if (totalPages <= maxLength) {
//     // no breaks in list
//     return range(1, totalPages);
//   }
//   if (page <= maxLength - sideWidth - 1 - rightWidth) {
//     // no break on left of page
//     return range(1, maxLength - sideWidth - 1)
//       .concat([0])
//       .concat(range(totalPages - sideWidth + 1, totalPages));
//   }
//   if (page >= totalPages - sideWidth - 1 - rightWidth) {
//     // no break on right of page
//     return range(1, sideWidth)
//       .concat([0])
//       .concat(range(totalPages - sideWidth - 1 - rightWidth - leftWidth, totalPages));
//   }
//   // Breaks on both sides
//   return range(1, sideWidth)
//     .concat([0])
//     .concat(range(page - leftWidth, page + rightWidth))
//     .concat([0])
//     .concat(range(totalPages - sideWidth + 1, totalPages));
// }

// jQuery(function() {
  
//   // Number of items and limits the number of items per page
//   var numberOfItems = parseInt(jQuery('.total-count').html());
//   var limitPerPage = parseInt(jQuery('.per-page').html());
//   // Total pages rounded upwards
//   var totalPages = numberOfItems;
//   // Number of buttons at the top, not counting prev/next,
//   // but including the dotted buttons.
//   // Must be at least 5:
//   var paginationSize = 10;
//   var currentPage;

//   function showPage(whichPage) {
//     if (whichPage < 1 || whichPage > totalPages) {
//       return false;
//     }
//     currentPage = whichPage;
//     // Replace the navigation items (not prev/next):            
//     jQuery("#pag1 li").slice(1, -1).remove();
//     jQuery("#pag2 li").slice(1, -1).remove();

//     getPageList(totalPages, currentPage, paginationSize).forEach(item => {
//       var el=jQuery("<li>").addClass("page-item pager__item pager__item--next")
//         .addClass(item ? "current-page" : "disabled more")
//         .toggleClass("active", item === currentPage)
//         .append(jQuery("<a href='" + window.location.pathname + "?page=" + item + "'>").addClass("page-link").text(item || "..."));

//       el.insertBefore( jQuery('.next-page') )
//     });
//     // Disable prev/next when at first/last page:
//     jQuery("#previous-page").toggleClass("disabled back", currentPage === 1);
//     jQuery("#next-page").toggleClass("disabled next", currentPage === totalPages);
//     return true;
//   }

//   // Include the prev/next buttons:
//   jQuery(".pagination").append(
//     jQuery("<li>").addClass("page-item back previous-page").attr({
//       id: "previous-page"
//     }).append(
//       jQuery("<a href='#'>").addClass("page-link").text("<")
//     ),
//     jQuery("<li>").addClass("page-item next next-page").attr({
//       id: "next-page"
//     }).append(
//       jQuery("<a href='#'>").addClass("page-link").text(">")
//     )
//   );
//   // Show the page links
//   showPage(1);

//   // Use event delegation, as these items are recreated later    
//   // jQuery(document).on("click", ".pagination li.current-page:not(.active)", function(e) {
//   //     e.preventDefault();
//   //   return showPage(parseInt(+jQuery(this).text()));
//   // });

//   jQuery(".pagination #next-page").on("click", function(e) {
//     e.preventDefault();
//     return showPage(currentPage + 5);
//   });

//   jQuery(".pagination #previous-page").on("click", function(e) {
//       e.preventDefault();
  
//     return showPage(currentPage - 5);
//   });

//   var ellipsisNext = function() {
//     jQuery('.pagination li#next-page').prev().prev().on("click", function(e) {
//       if (jQuery('.pagination li#next-page').prev().prev().text() == "...") {
//         e.preventDefault();
//         return showPage(currentPage + 5);
//       }
//     });
//   }
//   var ellipsisBack = function() {
//     jQuery(".pagination li#previous-page").next().next().on("click", function(e) {
//       if (jQuery('.pagination li#previous-page').next().next().text() == "...") {
//           e.preventDefault();
//         return showPage(currentPage - 5);
//       }
//     });
//   }
//   jQuery('#pag1, #pag2').click(function() {
//     ellipsisNext();
//     ellipsisBack();
//   })

// });